import actions from '@/store/modules/synthetics/commonState/commonState.action';
import mutations from '@/store/modules/synthetics/commonState/commonState.mutation';
import getters from '@/store/modules/synthetics/commonState/commonState.getter';

export interface State {
  services: any[];
  currentService: any;
  currentSMPage: any;
  isFormOpened: Boolean;
}

export const initialState: State = {
  services: [],
  currentService: {},
  currentSMPage: {},
  isFormOpened: false
};

export default {
  namespaced: true,
  state: initialState,
  actions: actions,
  mutations: mutations,
  getters: getters
};
